// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue';
import iView from 'iview';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import echarts from 'echarts';
import VCharts from 'v-charts';
import Print from 'vue-print-nb';
// import $ from 'jquery';
import JsonExcel from 'vue-json-excel';
import 'iview/dist/styles/iview.css';
import '../static/css/global.css';
import App from './App';
import router from './router/index.js';
import '../static/css/graph/graph.css'; // 引入知识图谱样式
import VueVideoPlayer from 'vue-video-player'; // 引入视频播放工具
import 'video.js/dist/video-js.css'; // 引入视频工具样式
import VueQriously from 'vue-qriously'; // 生成二维码的插件
// 解除Router调用promise报错
import Router from 'vue-router';
const originalPush = Router.prototype.push;
Router.prototype.push = function push (location) {
    return originalPush.call(this, location).catch(err => err);
};

Vue.directive('title', {
    inserted: function (el, binding) {
        document.title = el.dataset.title;
    }
});

Vue.prototype.$echarts = echarts;
// Vue.use(Upload);
// Vue.use(Tooltip);
// Vue.use(dialog);
Vue.use(iView);
Vue.use(ElementUI);
Vue.use(Print);
// Vue.use(Loading);
Vue.use(VCharts);
Vue.use(echarts);
Vue.use(VueVideoPlayer);
Vue.use(VueQriously);
Vue.config.productionTip = false;
Vue.component('downloadExcel', JsonExcel);

router.beforeEach((to, from, next) => {
    iView.LoadingBar.start();
    let head = document.getElementsByTagName('head');
    let meta = document.createElement('meta');
    meta.name = 'format-detection';
    meta.content = 'telephone=no';
    head[0].appendChild(meta);
    document.body.scrollTop = 0;
    next();
});

router.afterEach((to, from, next) => {
    iView.LoadingBar.finish();
    window.scrollTo(0, 0);
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js